"use client";

import { useElementOnScreen } from "@/hooks/useElementOnScreen";
import { clsx } from "clsx";
import { CheckCircle } from "lucide-react";
import { useTranslations } from "next-intl";

export function Engagements() {
  const { containerRef, isVisible } = useElementOnScreen();
  const t = useTranslations("engagements");

  return (
    <section ref={containerRef} className="py-24 bg-sand-dark">
      <div className="max-w-7xl mx-auto px-6">
        <div
          className={clsx(
            "fade-in-up mb-16 text-center",
            isVisible && "visible",
          )}
        >
          <h2 className="text-4xl md:text-5xl font-serif text-forest-green mb-4">
            {t("title")}
          </h2>
          <div className="line-accent mx-auto" />
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {[0, 1, 2].map((index) => (
            <div
              key={index}
              className={clsx(
                "fade-in-up bg-white-cream rounded-2xl p-8 shadow-lg",
                isVisible && "visible",
                index === 0 && "delay-100",
                index === 1 && "delay-200",
                index === 2 && "delay-300",
              )}
            >
              <h3 className="text-xl font-serif text-forest-green mb-6">
                {t(`items.${index}.title`)}
              </h3>
              <ul className="space-y-3">
                {t
                  .raw(`items.${index}.points`)
                  .map((item: string, i: number) => (
                    <li
                      key={i}
                      className="flex items-start gap-3 text-charcoal"
                    >
                      <CheckCircle className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" />
                      <span>{item}</span>
                    </li>
                  ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
